import SysColumn from "app/class/sys-column";

const TEXT_COMPARABLE_TYPES = new Set(["TEXT", "TABLE_NAME", "CHOICE"]);

export const isCompatibleColumnType = (column: SysColumn, selectedFieldType?: string) => {
    if (column.name === "value") {
        return false;
    }

    if (!selectedFieldType) {
        return true;
    }

    if (selectedFieldType === column.column_type) return true;
    if (TEXT_COMPARABLE_TYPES.has(selectedFieldType) && TEXT_COMPARABLE_TYPES.has(column.column_type)) return true;
    if (selectedFieldType === "TEXT" && column.column_type === "UUID") return true;
    if (selectedFieldType === "UUID" && column.column_type === "TEXT") return true;
    if (selectedFieldType === "UUID" && column.column_type === "REFERENCE") return true;

    if (
        (selectedFieldType === "INTEGER" || selectedFieldType === "DECIMAL") &&
        (column.column_type === "INTEGER" || column.column_type === "DECIMAL")
    ) {
        return true;
    }

    return false;
};
